import getGraphQlClient from '~graphql/getGraphQlClient';
import { FETCH_DELEGANTI } from '../queries/deleganti';
import { onErrorShowMessage } from '~src/errors';
import { unmarshalGraphqlResponse } from '~graphql/utils';

export const fetchDeleganti = async (where) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const result = await graphQlClient.query({
      variables: {
        where,
      },
      query: FETCH_DELEGANTI,
    });

    const deleganti = await unmarshalGraphqlResponse(result.data, 'famigliaris')
      .edges;

    return deleganti;
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};
